import { toast } from "sonner";

/**
 * Copies text to clipboard with a robust fallback for environments where
 * the async Clipboard API is blocked (e.g. preview iframes, insecure
 * contexts, or restrictive Permissions-Policy headers).
 */
export async function copyToClipboard(text, { silent = false } = {}) {
  if (text == null || text === "") return false;
  const value = String(text);

  // Try modern API first
  try {
    if (navigator?.clipboard?.writeText && window.isSecureContext !== false) {
      await navigator.clipboard.writeText(value);
      if (!silent) toast.success("Copied");
      return true;
    }
  } catch (_) {
    // fall through to legacy fallback
  }

  // Legacy fallback using a hidden textarea + execCommand
  try {
    const ta = document.createElement("textarea");
    ta.value = value;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    ta.style.pointerEvents = "none";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (ok) {
      if (!silent) toast.success("Copied");
      return true;
    }
    throw new Error("execCommand returned false");
  } catch (_) {
    if (!silent) toast.error("Copy failed — please copy manually");
    return false;
  }
}
